/**
 * @file `<ChapterHeader/>` — chapter eyebrow + H1 + subtitle.
 * @module @labcraft/course-kit/components/chapter-header
 *
 * Reads from the active `ChapterSpec` via {@link useChapter}. Rendered
 * once per chapter at the top of the chapter pane, under the progress
 * bar.
 */

import type { JSX } from 'react'
import { useChapter } from '../runtime/context.tsx'
import styles from './chapter_header.module.css'

export function ChapterHeader(): JSX.Element {
  const { spec } = useChapter()
  return (
    <header className={styles.header}>
      <span className={styles.eyebrow}>{spec.eyebrow}</span>
      <h1 className={styles.title}>{spec.title}</h1>
      {spec.subtitle && <p className={styles.subtitle}>{spec.subtitle}</p>}
    </header>
  )
}
